"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.array.index-of.js");

var _supportCss = _interopRequireDefault(require("../utils/supportCss3"));

var getElementTop = function getElementTop(el) {
  if (!el) {
    return;
  }

  var actualTop = el.offsetTop;
  var current = el.offsetParent;

  while (current !== null) {
    actualTop += current.offsetTop;
    current = current.offsetParent;
  }

  return actualTop;
};
/**
 * @function Sticky - 吸顶效果
 * @param {string} querySelector 目标dom
 * @param {string} placement 粘性位置，默认贴顶（贴底还没有兼容）
 * @example
 * import { Sticky } from '@zz-biz/utils';
 * 
 * Sticky(document.getElementById('#mubiao'));
 * 
 */


var sticky = function sticky(querySelector) {
  var placement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  try {
    var ele = querySelector;
    var top = getElementTop(ele);
    var sign = "utils-sticky-block-".concat(placement, "-").concat(location.hash.replace(/#\/|\/|\?.*/g, '') || 'index');
    var styleSelector = ".".concat(sign);
    var shadowContent = "".concat(placement, ":0;z-index:800;-moz-box-shadow:0px 5px 5px rgba(0, 0, 0, .1);-webkit-box-shadow:0px 5px 5px rgba(0, 0, 0, .1); box-shadow:0px 5px 5px rgba(0, 0, 0, .1);");
    var stylecontent = "position:fixed;".concat(shadowContent);
    var isScroll = false;
    var cssRuleState = false;

    if (!ele) {
      return;
    }

    if (ele.className.indexOf(sign) < 0) {
      ele.className += '' + sign;
    } // 支持stiky粘性布局属性的


    if ((0, _supportCss["default"])('position', 'sticky') || (0, _supportCss["default"])('position', '-webkit-sticky')) {
      var stylesheet = document.styleSheets[0];
      stylecontent = "position:sticky;position:-webkit-sticky;".concat(shadowContent);

      if (stylesheet.insertRule) {
        stylesheet.insertRule("".concat(styleSelector, "{").concat(stylecontent, "}"), 0);
      } else {
        stylesheet.addRule(styleSelector, stylecontent, 0);
      }

      return;
    } else {
      window.addEventListener('scroll', function () {
        if (!isScroll) {
          var _stylesheet = document.styleSheets[0];
          var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;

          if (top - scrollTop < 0) {
            if (ele && !cssRuleState) {
              if (_stylesheet.insertRule) {
                _stylesheet.insertRule("".concat(styleSelector, "{").concat(stylecontent, "}"), 0);
              } else {
                _stylesheet.addRule(styleSelector, stylecontent, 0);
              }

              cssRuleState = true;
            }
          } else {
            if (_stylesheet.cssRules[0]) {
              if (_stylesheet.deleteRule) {
                _stylesheet.deleteRule(0);
              } else {
                _stylesheet.removeRule(0);
              }
            }

            cssRuleState = false;
          }

          isScroll = true;
        }
      }, false);
    }
  } catch (err) {
    console.warn(err);
  }
};

var _default = sticky;
exports["default"] = _default;